module.exports = __webpack_public_path__ + "static/media/razorpay-logo.71f3e664.png";